import axios from "axios";

class RestClient {
  static GetRequest = (getUrl) => {
    return axios
      .get(getUrl)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return null;
      });
  };
  static PostRequest = (getUrl, postData) => {
    let config = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    return axios
      .post(getUrl, postData, config)
      .then((res) => {
        return res.data;
      })
      .catch(function (error) {
        return error;
      });
  };
}
export default RestClient;
